import { StatusBadge } from '@/components/ui';
import type { CellRendererProps } from './index';

export function StatusCell({ value }: CellRendererProps) {
  if (value == null || value === '') return null;
  return <StatusBadge status={String(value)} />;
}
